import { render, staticRenderFns } from "./RechargeDialog.vue?vue&type=template&id=5b6ee4f2"
import script from "./RechargeDialog.vue?vue&type=script&lang=js"
export * from "./RechargeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports